import PropTypes from "prop-types";
import React, { Component } from "react";
import { Select } from "semantic-ui-react";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";

export class RJSFDependentVocabulary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredOptions: [],
      isLoading: false,
      error: null,
      dependentValue: null,
    };
  }

  componentDidMount() {
    this.updateFilteredOptions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.formContext !== this.props.formContext) {
      this.updateFilteredOptions();
    }
  }

  getDependentValue = () => {
    const { options, formContext } = this.props;
    const { dependsOn } = options;

    if (!dependsOn || !formContext) return null;

    const value = _get(formContext, dependsOn);

    return value;
  };

  updateFilteredOptions = () => {
    const dependentValue = this.getDependentValue();

    if (dependentValue !== this.state.dependentValue) {
      this.setState({ dependentValue }, () => {
        this.filterOptions();
      });
    }
  };

  filterOptions = () => {
    const { dependentValue } = this.state;
    const { options } = this.props;
    const { programsByCollege = {} } = options;

    if (!dependentValue || _isEmpty(programsByCollege)) {
      this.setState({ filteredOptions: [] });
      return;
    }

    const collegeId = String(dependentValue);
    const collegePrograms = programsByCollege[collegeId] || [];

    const filtered = collegePrograms.map((program) => ({
      key: program.code,
      value: program.code,
      text: program.name,
    }));

    this.setState({ filteredOptions: filtered });
  };

  handleChange = (event, { value: selectedValue }) => {
    const { onChange } = this.props;
    onChange(selectedValue === "" ? undefined : selectedValue);
  };

  render() {
    const { id, value, disabled, readonly, placeholder, required, options } =
      this.props;

    const { filteredOptions, isLoading, error, dependentValue } = this.state;

    const {
      dependsOn,
      placeholder: configPlaceholder = "Select an option...",
      emptyText = "No options available",
    } = options;

    const showEmptyState = !dependentValue;
    const showNoOptions = dependentValue && filteredOptions.length === 0;

    let effectivePlaceholder = placeholder || configPlaceholder;
    if (showEmptyState && dependsOn) {
      effectivePlaceholder = "Select department first...";
    }

    return (
      <Select
        id={id}
        value={value || ""}
        onChange={this.handleChange}
        placeholder={effectivePlaceholder}
        disabled={disabled || readonly || showEmptyState || isLoading}
        loading={isLoading}
        clearable
        search
        selectOnBlur={false}
        selectOnNavigation={false}
        options={filteredOptions}
        error={!!error}
        fluid
        noResultsMessage={
          showNoOptions
            ? emptyText
            : error
            ? "Error loading options"
            : "No results found"
        }
        required={required}
      />
    );
  }
}

RJSFDependentVocabulary.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.shape({
    programsByCollege: PropTypes.object,
    dependsOn: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    emptyText: PropTypes.string,
    resetOnChange: PropTypes.bool,
  }).isRequired,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  formContext: PropTypes.object,
};

RJSFDependentVocabulary.defaultProps = {
  disabled: false,
  readonly: false,
  required: false,
  formContext: {},
};
